export default __webpack_public_path__ + "static/media/sideLogo.46ac39c8.svg";